import React, { useState, createContext, useContext } from 'react';
import { X, Wrench } from 'lucide-react';

// Set to false to hide the banner
const MAINTENANCE_ACTIVE = false;

const MaintenanceContext = createContext(false);

export function useMaintenanceActive() {
  return useContext(MaintenanceContext);
}

export function MaintenanceBanner({ children }: { children: React.ReactNode }) {
  const [dismissed, setDismissed] = useState(false);
  const isVisible = MAINTENANCE_ACTIVE && !dismissed;

  return (
    <MaintenanceContext.Provider value={isVisible}>
      {isVisible && (
        <div className="sticky top-0 bg-amber-500 text-black text-center text-sm font-medium px-4 py-2.5 z-[60]">
          <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 pr-8">
            <Wrench className="w-4 h-4 shrink-0" />
            <span>
              Scheduled maintenance – ordering may be temporarily unavailable. Please check back shortly or{' '}
              <a href="/contact" className="underline font-bold hover:no-underline">contact us</a>.
            </span>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full hover:bg-black/10 transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      )}
      {children}
    </MaintenanceContext.Provider>
  );
}
